import React from 'react';

import { User } from '~/modules/accessControl/@types/user';
import { Option } from '~/shared/components/InputChakra/SelectChakra';

export default function getOptionsAllowedResponsibles(
  activityResponsibles: Array<{ id: number; name: string }> | undefined,
  users: User[],
): Option[] {
  return users
    .filter(
      (us) =>
        !activityResponsibles?.length ||
        !!activityResponsibles?.find((act) => act.id === us.responsibility_id),
    )
    .map((us) => ({
      label: `${us.name} (${us.responsibility})`,
      value: us.id,
    }));
}
